import { useEffect, useRef } from 'react';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import { Box } from '@mui/material';
import animationData from '@/assets/splashNB.json';

interface AnimatedLogoProps {
  size?: number;
}

export const AnimatedLogo = ({ size = 40 }: AnimatedLogoProps) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    // 5 секунд воспроизведение + 5 секунд пауза = 10 секунд цикл
    const playDuration = 5000;
    const pauseDuration = 5000;
    const cycleDuration = playDuration + pauseDuration;

    const startCycle = () => {
      if (lottieRef.current) {
        lottieRef.current.goToAndPlay(0);
      }

      // Останавливаем через 5 секунд
      setTimeout(() => {
        if (lottieRef.current) {
          lottieRef.current.pause();
        }
      }, playDuration);
    };

    // Запускаем сразу
    startCycle();

    // Повторяем каждые 10 секунд
    const interval = setInterval(startCycle, cycleDuration);

    return () => clearInterval(interval);
  }, []);

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '10px',
        backgroundColor: '#36C65A',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Lottie
        lottieRef={lottieRef}
        animationData={animationData}
        loop={false}
        autoplay={false}
        style={{
          width: size,
          height: size,
        }}
      />
    </Box>
  );
};
